import { Routes, Route } from 'react-router-dom';
import { RootLayout } from './components/layout/root-layout';
import { ModernHomePage } from './pages/modern-home';
import { ModernProductsPage } from './pages/modern-products';
import { ModernCategoriesPage } from './pages/modern-categories';
import { ModernProductDetailPageV2 } from './pages/modern-product-detail-v2';
import { CartPage } from './pages/cart';
import { ModernWishlistPage } from './pages/modern-wishlist';
import { SettingsPage } from './pages/settings';
import { TrackPage } from './pages/track';
import { AboutPage } from './pages/about';
import { ContactPage } from './pages/contact';
import { OrderCompletePage } from './pages/order-complete';
import { FAQPage } from './pages/faq';
import { ReturnPolicyPage } from './pages/return-policy';
import { PrivacyPolicyPage } from './pages/privacy-policy';
import { TermsOfServicePage } from './pages/terms-of-service';
import { NewStripePaymentPage } from './pages/stripe-payment-new';
import { SiteNotFoundPage } from '@/pages/site-not-found';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<RootLayout />}>
        <Route index element={<ModernHomePage />} />
        <Route path="home" element={<ModernHomePage />} />
        <Route path="products" element={<ModernProductsPage />} />
        <Route path="product/:id" element={<ModernProductDetailPageV2 />} />
        <Route path="cart" element={<CartPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="categories" element={<ModernCategoriesPage />} />
        <Route path="wishlist" element={<ModernWishlistPage />} />
        <Route path="track" element={<TrackPage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="order-complete" element={<OrderCompletePage />} />
        <Route path="stripe-payment" element={<NewStripePaymentPage />} />
        <Route path="faq" element={<FAQPage />} />
        <Route path="return-policy" element={<ReturnPolicyPage />} />
        <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="terms-of-service" element={<TermsOfServicePage />} />
        <Route path="*" element={<SiteNotFoundPage />} />
      </Route>
    </Routes>
  );
}
